import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textSObj, heading4Obj } = typographyStyles;
const blue = colors.brand.blue[25];
const darkBlue = colors.ui.core[700];

export const messageContainerCss = {
  display: "flex",
  backgroundColor: colors.brand.blue[25],
  borderRadius: "8px",
  margin: "24px 24px 0 24px",
  padding: "16px",
};

export const textCss = [
  {
    color: darkBlue,
  },
  textSObj,
];

export const iconCss = {
  marginRight: "8px",
  width: "20px",
  height: "20px",

  circle: {
    fill: darkBlue,
    stroke: darkBlue,
  },

  path: {
    stroke: blue,
  },
};

export const titleCss = [
  {
    width: "max-content",
  },
  heading4Obj,
];
